<app-option-bar [type]="'MASTERSUITE'" [details]="mastersuiteDetails"></app-option-bar>
<div class="container-fluid testsuite-list-wrapper">
  <div class="content-wrapper">
    <div class="inner-nav">
      <app-left-menu [details]="mastersuiteDetails" [type]="'MASTERSUITE'"></app-left-menu>
    </div>
    <div class="inner-content collapsed">
      <div class="common-section">
        <form [formGroup]="historyListSearchForm" (ngSubmit)="pagination()" class="search-form">
          <div class="row mt-2">
            <div class="col">
              <label for="executed-by">Executed By</label>
              <ng-select class="custom-style" id="executed-by" [items]="users" bindLabel="displayName" bindValue="id"
                placeholder="Select executed by" [searchable]="true" [multiple]="false" formControlName="executedBy">
                <ng-option [value]="">Select executed by</ng-option>
              </ng-select>
            </div>
            <div class="col">
              <label for="locator-project">Execution Status</label>
              <ng-select class="custom-style" id="execution-status" [items]="executionStatusList"
                placeholder="Select Status" [searchable]="true" [multiple]="false" formControlName="executionStatus">
                <ng-option [value]="">Select Status</ng-option>
              </ng-select>
            </div>
            <div class="col">
              <label for="exec-type">Execution Type</label>
              <ng-select class="custom-style" id="execution-status" [items]="execTypes" placeholder="Select"
                [searchable]="true" [multiple]="false" formControlName="execType">
                <ng-option [value]="">Select Status</ng-option>
              </ng-select>
            </div>
            <div class="col">
              <label for="from-date">From</label>
              <input id="from-date" class="form-control form-control-sm" container="body" placeholder="yyyy-mm-dd"
                ngbDatepicker #fromDateDp="ngbDatepicker" formControlName="fromDate" [maxDate]="maxDate"
                (click)="fromDateDp.toggle()" (ngModelChange)="setMindate()" autocomplete="off">
            </div>
            <div class="col">
              <label for="to-date">To</label>
              <input id="to-date" class="form-control form-control-sm" container="body" placeholder="yyyy-mm-dd"
                ngbDatepicker #toDateDp="ngbDatepicker" [minDate]="minDate"
                [disabled]="historyListSearchForm?.value.fromDate === null" [maxDate]="maxDate" formControlName="toDate"
                (click)="toDateDp.toggle()" autocomplete="off">
            </div>
          </div>
          <div class="form-row mt-2">
            <div class="col-6">
              <a id="clear" (click)="clearSearchFilter()" class="clear-filter">
                <i>Clear filter</i>
              </a>
            </div>
            <div class="col-6 text-right">
              <button id="submit-form" (click)="pagination()" class="btn btn-primary btn-sm"
                name="button">Search</button>
            </div>
          </div>
        </form>
      </div>
      <div class="mt-3">
        <table class="table table-hover table-list-design">
          <thead>
            <tr>
              <th></th>
              <th>Start Time</th>
              <th>End Time</th>
              <th>Environment Mapper</th>
              <th>Executed by</th>
              <th>Scheduled</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="collectionSize === 0">
              <td colspan="6">No data found</td>
            </tr>
            <tr *ngIf="collectionSize === null">
              <td colspan="6">Please wait fetching data ...</td>
            </tr>
            <tr *ngFor="let masterSuite of executionsList">
              <td>
                <a [routerLink]="['../result']" [queryParams]="{noSqlId: masterSuite.execution.noSqlId}"
                  target="_blank"><i class="fas fa-external-link-alt"></i></a>
                <i class="fas fa-file-export clickable ml-3" ngbTooltip="Export Extracted Global Test Data"
                  placement="right" (click)="exportExtractedGlobalTestData(masterSuite.execution)"
                  style="color: #0288d1;;"></i>
              </td>
              <td>
                <div *ngIf="masterSuite.execution.startTime !== null">{{masterSuite.execution.startTime |
                  localDate}}</div>
                <div *ngIf="masterSuite.execution.startTime === null">{{masterSuite.execution.executedOn |
                  localDate}}</div>
              </td>
              <td>
                <div *ngIf="masterSuite.execution.endTime === null">N/A</div>
                <div *ngIf="masterSuite.execution.endTime !== null">
                  {{masterSuite.execution.endTime | localDate}}</div>
              </td>
              <td>
                <div class="overflow-div-td">
                  {{ masterSuite.environmentMap.name }}
                </div>
              </td>
              <td>{{masterSuite.execution.executedBy}}</td>
              <td *ngIf="masterSuite.execution.fromScheduler">YES</td>
              <td *ngIf="!masterSuite.execution.fromScheduler">NO</td>
              <td [ngClass]="masterSuite.execution.executionStatus">
                {{masterSuite.execution.executionStatus}}
              </td>
            </tr>
          </tbody>
        </table>
      </div>


      <div class="row">
        <div class="col font-weight-bold">Total Results : {{collectionSize || 0}} </div>
        <div class="col-1" *ngIf="executionsList">
          <select class="form-control form-control-sm" (change)="onSizeChange(pageSize)" [(ngModel)]="pageSize">
            <option>15</option>
            <option>25</option>
            <option>50</option>
            <option>100</option>
          </select>
        </div>
        <div class="col-md-auto" *ngIf="executionsList">
          <ngb-pagination class="d-flex justify-content-end" [collectionSize]="collectionSize" [maxSize]="5"
            [pageSize]="pageSize" [(page)]="page" [boundaryLinks]="true" [rotate]="true"
            (pageChange)="onPageChange($event)"></ngb-pagination>
        </div>
      </div>
    </div>
  </div>
</div>